export const apiUrl = "https://api-mobile-app.temblor.net";
export const webAppUrl = "https://app.temblor.net";
export const mapboxAccessToken =
  "pk.eyJ1IjoidGVtYmxvciIsImEiOiI5MjdjOTMxNTJiZmFlZmU1ZGI0ZjAwNTZlNjEyOWEwNyJ9.a1_DS6D2ipZAP1AS2OyAHQ";
export const basePath = window.cordova ? "./" : "/";
